export const DevelopModuleTranslations: Array<string> = [
    'xmlGlobalScripts',
    'Admin.Msg.AddNew',
    'Admin.Msg.EditTitle',
    'GlobalScripts.ScriptUsage',
    'xsltDelete',
    'Admin.Users.DeleteWarning',
    'Admin.SuccessfullyDeleted',
    'Admin.GlobalScripts.QuickSearch',
    'Admin.GlobalScripts.TotalGlobalScripts',
    'Admin.Scripts.Name',
    'Admin.GlobalScripts.ExecutionEvents',
    'Admin.Scripts.Code',
    'Admin.Scripts.Description',
    'Admin.AddEditScript.Active',
    'AddEditSystemEventScript.Script',
    'Msg.Yes',
    'Msg.No',
    'Admin.AddEditScript.IsModule',
    'Admin.AddEditScript.IsCSRFProtected',
    'Admin.AddEditScript.IsCSRFProtectedHint',
    'Admin.AddEditScript.IsModuleHint',
    'Admin.GlobalScripts.ScriptCodeInfo',
    'Admin.Scripts.ModifiedDate',
    'Admin.Scripts.ModifiedBy',
    'xmlActions',
    'Admin.GlobalScripts.ScriptCode',
    'Admin.AddEditScript.StartDate',
    'Admin.AddEditScript.EndDate',
    'Versions.SelectExactlyTwoVersionToCompare',
    'GlobalScripts.ScriptUsage.CheckIfIsInUse',
    'GlobalScripts.ScriptUsage.GlobalScriptName',
    'GlobalScripts.ScriptUsage.Products',
    'GlobalScripts.ScriptUsage.ProductAttributes',
    'GlobalScripts.ScriptUsage.Events',
    'GlobalScripts.ScriptUsage.Scripts',
    'GlobalScripts.ScriptUsage.CustomActions',
    'GlobalScripts.ScriptUsage.CustomQuoteCalculations',
    'Msg.Close',
    'Msg.NotUsed',
    'Admin.AddEditScript.Events',
    'Admin.Msg.NoResultsSearch',
    'Msg.ShowOnlySelected',
    'Admin.GlobalScriptEvents.AddCustomField',
    'Admin.GlobalScriptEvents.AddTab',
    'Admin.GlobalScriptEvents.SelectEvent',
    'Admin.GlobalScriptEvents.SetScriptExecutionOrder',
    'Admin.GlobalScriptEvents.Search'
];
